import { Dispatch } from "redux";
import { FilterTab } from "@hatch-digital-nl/abs-storybook/legacy";
import {
    getQualificationTypeLabel,
    QualificationTypeEnum,
} from "../../../common/enums/QualificationTypeEnum";
import { setMissingCertificatesWidgetFilters } from "../DashboardSlice";

export const getFilterTabs = (
    dispatch: Dispatch,
    activeTab: string,
): FilterTab[] => {
    return [
        {
            title: getQualificationTypeLabel(QualificationTypeEnum.PERSON),
            onClick: () =>
                dispatch(
                    setMissingCertificatesWidgetFilters({
                        activeTab: QualificationTypeEnum.PERSON,
                    }),
                ),
            isActive: activeTab === QualificationTypeEnum.PERSON,
        },
        {
            title: getQualificationTypeLabel(
                QualificationTypeEnum.ESTABLISHMENT,
            ),
            onClick: () =>
                dispatch(
                    setMissingCertificatesWidgetFilters({
                        activeTab: QualificationTypeEnum.ESTABLISHMENT,
                    }),
                ),
            isActive: activeTab === QualificationTypeEnum.ESTABLISHMENT,
        },
    ];
};
